module.exports = __webpack_public_path__ + "static/media/mode-531.ae4c4b66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-531.svg
// module id = 1049
// module chunks = 2